/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "./Select";
import Load from "../ingka/Load";
import SearchBar from "../ingka/SearchBar";
import Text from "../ingka/Text";
import { useAddons } from "../../hooks/use-addons";
import { useAddonsUpdate } from "../../hooks/use-addons-update";
import { useProduct } from "../../hooks/use-product";
import PropTypes from "prop-types";

export default function AddAddon({
  type,
  addonEdit,
  save,
  disabledSave,
  mode,
  points,
  mapId,
  updateAddonsState,
  level,
}) {
  const [t] = useTranslation("global");
  const productIcon =
    "m12 2 9 4.989v10.022L12 22l-9-4.989V6.989L12 2zm0 2.2614-5.9603 3.304L12 10.8692l5.9603-3.304L12 4.2613zM5 15.8583v-6.608l6 3.326v6.608l-6-3.326zm8 3.326 6-3.326v-6.608l-6 3.326v6.608z";

  const [addon, setAddon] = useState(null);
  const [ref, setRef] = useState(null);
  const [validateRef, setValidateRef] = useState(true);
  const { addonsOptions, isLoadingAddons } = useAddons({ mode, level });
  const { addonsUpdate, isLoadingAddonsUpdate } = useAddonsUpdate();
  const { getProduct, isLoadingProduct, product } = useProduct();

  useEffect(() => {
    if (mode !== "marker" && type === "PUT") {
      setAddon({
        icon: productIcon,
        value: addonEdit.type.value,
        label: addonEdit.type.label,
      });
    }
  }, []);

  useEffect(() => {
    if (type === "PUT" && mode === "marker" && addonsOptions.length > 0) {
      const theAddon = addonsOptions.find(
        (el) => el.value === addonEdit.type.value
      );
      setAddon(theAddon);
    }
  }, [addonsOptions, addonEdit, mode, type]);

  useEffect(() => {
    if (addon) {
      disabledSave(false);
    }
  }, [addon, disabledSave]);

  useEffect(() => {
    if (ref) {
      if (ref.length === 8) {
        setValidateRef(null);
        getProduct(ref);
      } else {
        setValidateRef(false);
      }
    }
  }, [ref]);

  useEffect(() => {
    if (product) {
      setAddon({
        icon: productIcon,
        value: product.data[0].itemKey.itemNo,
        label: product.data[0].productNameGlobal,
      });
    }
  }, [product]);

  useEffect(() => {
    if (save) {
      addonsUpdate(
        {
          type,
          mode,
          addon,
          addonEdit,
          points,
          mapId,
          level,
          successMsg: t("map.success" + type + mode),
        },
        {
          onSuccess: (response) => {
            updateAddonsState({ ...response, isMarker: mode === "marker" });
          },
        }
      );
    }
  }, [save]);

  return (
    <div style={{ minHeight: 300 }}>
      {(isLoadingAddons || isLoadingAddonsUpdate || isLoadingProduct) && (
        <Load />
      )}
      {(!isLoadingAddons || !isLoadingAddonsUpdate) && (
        <>
          {mode === "marker" && (
            <Select
              formField={{ className: "col-12" }}
              label={t("map.whatAdd")}
              defaultValue={addon}
              value={addon}
              onChange={(val) => setAddon(val)}
              isClearable={false}
              isSearchable={false}
              id="type"
              name="type"
              options={addonsOptions}
            />
          )}
          {mode === "addon" && (
            <>
              <SearchBar
                ariaLabel="Search for product categories, product names, etc."
                placeholder={t("map.searchByRef")}
                clearBtnText={t("global.delete")}
                id="search"
                onSearch={(e, data) => setRef(data.value)}
                submitBtnText={t("global.search")}
              />
              {validateRef !== null && (
                <Text
                  tagName="p"
                  bodySize="s"
                  className={!validateRef ? "text-red" : ""}
                >
                  La referencia ha de tener 8 caracteres Ejemplpos: 10458098,
                  40457988, 60458581
                </Text>
              )}
              {addon && (
                <>
                  <Text tagName="h3" bodySize="xl" className="mb-0">
                    {addon.label}
                  </Text>
                  <Text tagName="p" bodySize="m" className="mt-0">
                    REF: {addon.value}
                  </Text>
                </>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}

AddAddon.propTypes = {
  mode: PropTypes.oneOf(["marker", "addon"]),
  type: PropTypes.oneOf(["POST", "PUT"]),
  addon: PropTypes.shape({
    icon: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  addonEdit: PropTypes.shape({
    type: PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  }),
  points: PropTypes.number,
  mapId: PropTypes.string,
  level: PropTypes.number,
  save: PropTypes.bool,
  disabledSave: PropTypes.func,
  updateAddonsState: PropTypes.func,
};